import React, { useEffect } from 'react'
import { connect } from 'react-redux'
import paths from 'constants/paths'
import propTypes from 'global/propTypes'
import PropTypes from 'prop-types'
import { selectors } from 'domain'
import { useNavigate } from 'react-router-dom'
import userRoles from 'constants/userRoles'

import Search from './Search'

const SearchContainer = ({ signedInAs, userRole }) => {
  const navigate = useNavigate()

  useEffect(() => {
    if (!signedInAs) {
      navigate(paths.login)
    }
  }, [navigate, signedInAs])

  return signedInAs && userRole !== userRoles.SHIP && <Search />
}

SearchContainer.defaultProps = {
  signedInAs: null,
  userRole: null,
}

SearchContainer.propTypes = {
  signedInAs: PropTypes.string,
  userRole: propTypes.userRole,
}

const mapStateToProps = state => ({
  signedInAs: selectors.signedInAsSelector(state),
  userRole: selectors.userRoleSelector(state),
})

export default connect(mapStateToProps)(SearchContainer)
